import React, {useEffect, useRef, useState} from "react";
import "./style.scss";
import {FAQ, MONEY_BACK_POLICY, PRIVACY_POLICY, TERMS_OF_USE} from "../../../enum/NavigationEnum";
export const Support = ({setDisplayNav}) => {
    return (
        <div className={"support-popup"}>
            <div className={'support-popup-right'}>
                <div className={'support-popup-top'}>
                    <div className={'support-popup-top-content'}>
                        Docs
                    </div>
                    <img src={"/static/image/icon/close-icon.png"} className={'support-popup-top-icon'} onClick={() => {setDisplayNav(false)}} />
                </div>
                <div className={'support-popup-items'}>
                    <div className={'support-popup-item'} onClick={() => {setDisplayNav(PRIVACY_POLICY)}}>
                        Privacy Policy
                    </div>
                    <div className={'support-popup-item'} onClick={() => {setDisplayNav(TERMS_OF_USE)}}>
                        Terms of Use
                    </div>
                    <div className={'support-popup-item'} onClick={() => {setDisplayNav(MONEY_BACK_POLICY)}}>
                        Money Back Policy
                    </div>
                    <div className={'support-popup-item'} onClick={() => {setDisplayNav(FAQ)}}>
                        FAQ
                    </div>
                </div>
                <div className={'support-popup-bottom'}>
                    We will be glad to assist you via email. Please send your questions and feedback here or to:
                    <br/>
                    <span>website@caloapp.ai</span>
                </div>
            </div>
        </div>
    );
};

Support.propTypes = {};
